<div class="flex items-center gap-x-3 w-full">
  @if (option) {
    <parkour-profiel-foto-badge size="2.5" [profiel]="optionToProfielData(option)" [alt]="false" />

    <p>{{ option.teamOwnerNaam }}</p>
  }
</div>
